<template>
    <div>
        <simple-layout horizontal>
            <accounts-card
              :account-ownerships="accountOwnerships"
              @focusedChanged="handleFocusedChanged"
              @delete="handleDelete">
                <account-form-card
                  v-if="focusedAccount != null"
                  :account="focusedAccount"
                  :account-ownership="selectedAccountOwnership"
                  @save="handleSave"
                />
            </accounts-card>
        </simple-layout>
    </div>
</template>

<script>
import DashboardLayout from "../components/layout/DashboardLayout";
import BasicCard from "../components/layout/BasicCard";
import AccountsCard from "../cards/AccountsListCard";
import MultiCardLayout from "../components/layout/MultiCardLayout";
import SingleAccountCard from "../cards/SingleAccountCard";
import { mapGetters } from "vuex";
import AccountFormCard from "../cards/AccountFormCard";
import SimpleLayout from "../components/layout/SimpleLayout";

export default {
    name: "AccountsView",
    components: {
        SimpleLayout,
        AccountFormCard, SingleAccountCard, MultiCardLayout, AccountsCard, BasicCard, DashboardLayout
    },
    props: {
        internal: Boolean
    },
    data: function () {
        return {
            focusedAccount: null,
            selectedAccountOwnership: null,
            query: {parameters: {internal: {operator: "in", value: "true", type: "boolean", negation: false}}},
        }
    },
    mounted() {
        // Promise.all([this.$store.dispatch("banking/refreshAccounts"),
        //     this.$store.dispatch("banking/refreshBanks")])
        //     .then(() => this.$store.dispatch("banking/refreshAllBalances"));
    },
    methods: {
        handleFocusedChanged(focused) {
            this.focusedAccount = focused;
            if (focused)
                this.selectedAccountOwnership = [...this.accountOwnerships.filter(accOwnership => accOwnership.accountId == this.focusedAccount.id), {}][0];
        },
        handleDelete(item) {
            this.$store.dispatch("banking/deleteAccount", item);
        },
        handleSave(account, accountOwnership) {
            delete account.changeLogs;
            Promise.all([this.$store.dispatch("banking/saveAccount", account),
                this.$store.dispatch("accountOwnerships/saveAccountOwnership",
                  {id: accountOwnership.id, accountId: account.id, partyRoleId: accountOwnership.partyRoleId})])
              .then(() => {
                  this.$store.dispatch(`accountListing/refreshAccountsPaged`, {page: 0, query: this.query})
                    .then(() => this.loading = false)
              })
              .catch(err => {

                  this.$notify({
                      group: 'application',
                      title: 'Saving failed',
                      text: err.message,
                      type: "error"
                  })
              })
            //.then(() => this.$store.dispatch("banking/refreshAllBalances"))

            this.focusedAccount = null;
            this.selectedAccountOwnership = null;
        }
    },
    computed: {
        ...mapGetters({
            accountOwnerships: "accountOwnerships/accountOwnerships",
            accountBalances: 'banking/accountBalances'
        })
    }
}
</script>

<style lang="scss" scoped>

</style>